<ng-container *ngIf="viewModel$ | async as viewModel">
  <section class="p-mt-5">
    <header>
      <div>
        <h2><i class="pi pi-calendar p-mr-1"></i> Timeline</h2>
      </div>
    </header>
    <main class="p-mt-4" *ngIf="viewModel.jobLoaded; else loading">
      <app-availability-schedule></app-availability-schedule>
      <div class="flex-1 events-wrapper">
        <div class="empty-state" *ngIf="viewModel.events.length === 0">
          <i class="pi pi-calendar-clock"></i>
          <span>No events for this job.</span>
        </div>

        <article
          *ngFor="let jobEvent of viewModel.events; let eventIndex = index"
          [style]="jobEvent.style"
        >
          <div
            class="eventDetails"
            (click)="
              store.dispatch(
                actions.eventDetailsClicked({ eventId: jobEvent.event.id })
              )
            "
          >
            <p class="title">{{ jobEvent.title }}</p>
            <p class="info">{{ jobEvent.datetime }}</p>
            <p class="info">
              {{ jobEvent.secondLineDetails }}
            </p>
          </div>
          <div class="flex align-items-center gap-2">
            <p-button
              *ngIf="viewModel.crewNavigatorEnabled && viewModel.canRunNavigator && (jobEvent.event.status === 'booked' || jobEvent.event.status === 'confirmed' || (jobEvent.event.status === 'completed' && jobEvent.navigatorStarted && jobEvent.event.navigatorCurrentStep !== 'completed')) && jobEvent.hasNavigatorUrl"
              icon="pi pi-play"
              [label]="jobEvent.navigatorStarted ? 'Continue' : 'Start Navigator'"
              styleClass="p-button-sm p-button-success"
              (onClick)="
                store.dispatch(
                  workOrdersActions.startEventButtonClicked({
                    eventId: jobEvent.event.id,
                  })
                )
              "
            />
            <p-button
              *ngIf="jobEvent.event.status !== 'cancelled'"
              icon="pi pi-arrow-right"
              [text]="true"
              (onClick)="
                store.dispatch(
                  actions.goToEventButtonClicked({
                    eventId: jobEvent.event.id,
                  })
                )
              "
            />
            <p-button
              *ngIf="jobEvent.event.status === 'cancelled'"
              icon="pi pi-undo"
              label="Uncancel"
              [text]="true"
              (onClick)="
                store.dispatch(
                  actions.uncancelEventButtonClicked({
                    eventId: jobEvent.event.id,
                  })
                )
              "
            />
          </div>
        </article>
      </div>
    </main>
  </section>

  <p-menu #menu [model]="viewModel.eventMenuItems" [popup]="true" />

  <ng-template #loading>
    <main class="p-mt-4">
      <p-skeleton
        class="flex-1"
        *ngFor="let _ of [1, 2, 3]"
        width="100%"
        height="5rem"
      />
    </main>
  </ng-template>
</ng-container>
